import { render, staticRenderFns } from "./SpecialNavBarLayout.vue?vue&type=template&id=2f13a87c&scoped=true&"
import script from "./SpecialNavBarLayout.vue?vue&type=script&lang=ts&"
export * from "./SpecialNavBarLayout.vue?vue&type=script&lang=ts&"
import style0 from "./SpecialNavBarLayout.vue?vue&type=style&index=0&id=2f13a87c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f13a87c",
  null
  
)

export default component.exports